// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { updatePayment } from "../../../Redux/Customers/Payment/Action";
// import { Alert, AlertTitle, Grid } from "@mui/material";
// import { getOrderById, updateAwbNumber } from "../../../Redux/Customers/Order/Action";
// import OrderTraker from "../orders/OrderTraker";
// import AddressCard from "../adreess/AdreessCard";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import { getCart } from "../../../Redux/Customers/Cart/Action";

// const PaymentSuccess = () => {
//   const [paymentId, setPaymentId] = useState("");
//   const [paymentStatus, setPaymentStatus] = useState("");
//   const [jwtToken, setJwtToken] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [waybillData, setWaybillData] = useState(null);
//   const [error, setError] = useState(null);

//   const { orderId } = useParams();
//   const jwt = localStorage.getItem("jwt");
//   const dispatch = useDispatch();
//   const cart = useSelector((store) => store.cart);
//   const order = useSelector((store) => store.order);
//   console.log(order?.order?.totalPrice,"new orders price check");

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     setPaymentId(urlParams.get("razorpay_payment_id"));
//     setPaymentStatus(urlParams.get("razorpay_payment_link_status"));
//   }, []);

//   useEffect(() => {
//     if (orderId) {
//       const storedWaybill = localStorage.getItem(`waybill_result_for_${orderId}`);
//       if (storedWaybill) {
//         setWaybillData(JSON.parse(storedWaybill));
//       }
//     }
//   }, [orderId]);

//   useEffect(() => {
//     const getBlueDartToken = async () => {
//       try {
//         const tokenRes = await axios.get(
//           "https://apigateway.bluedart.com/in/transportation/token/v1/login",
//           {
//             headers: {
//               Accept: "application/json",
//               ClientID: "uTGmdHAufhKOiDQG9El8LAS66HG539yT",
//               ClientSecret: "qKA8mU7UKlw7Ah8h",
//             },
//           }
//         );
//         setJwtToken(tokenRes.data.JWTToken);
//       } catch (err) {
//         setError("Failed to get Blue Dart token");
//       }
//     };
//     getBlueDartToken();
//     dispatch(getCart(jwt));
//   }, [jwt, dispatch]);

//   useEffect(() => {
//     if (orderId) {
//       dispatch(getOrderById(orderId));
//     }
//   }, [orderId, dispatch]);

//   useEffect(() => {
//     const awbKey = `awb_generated_for_${orderId}`;
//     const alreadyGenerated = localStorage.getItem(awbKey);
//     const _order = order?.order;

//     if (
//       paymentStatus === "paid" &&
//       paymentId &&
//       _order &&
//       _order.shippingAddress &&
//       jwtToken &&
//       !alreadyGenerated
//     ) {
//       dispatch(updatePayment({ orderId, paymentId, jwt }));
//       generateWaybill(_order.shippingAddress, jwtToken);
//       localStorage.setItem(awbKey, "true");
//     }
//   }, [paymentStatus, paymentId, orderId, order.order, jwtToken, dispatch]);

//   const getCommodityDetails = () => {
//     const validItems = cart?.cartItems?.filter((item) => item?.product?.title) || [];
//     const commodityDetails = {};
//     validItems.forEach((item, index) => {
//       commodityDetails[`CommodityDetail${index + 1}`] = item.product.title;
//     });
//     if (validItems.length === 0) {
//       commodityDetails["CommodityDetail1"] = "No items";
//     }
//     return commodityDetails;
//   };

//   const generateWaybill = async (address, token) => {
//     if (!address || !token) return;

//     const randomSixDigit = Math.floor(100000 + Math.random() * 900000);
//     const requestData = {
//       Request: {
//         Consignee: {
//           ConsigneeAddress1: address.streetAddress,
//           ConsigneeAddress2: address.city,
//           ConsigneeAddress3: address.city,
//           ConsigneeMobile: address.mobile,
//           ConsigneeName: address.firstName,
//           ConsigneePincode: address.zipCode,
//         },
//         Returnadds: {},
//         Services: {
//           ActualWeight: "1.0",
//           CollectableAmount: 0.0,
//           Commodity: getCommodityDetails(),
//           CreditReferenceNo: randomSixDigit,
//           DeclaredValue: order?.order?.totalPrice,
//           Dimensions: [{ Breadth: 10.0, Count: 1, Height: 10.0, Length: 20.0 }],
//           ItemCount: 1,
//           PickupDate: "/Date(1736504552000)/",
//           PickupTime: "1600",
//           PickupType: "O",
//           PieceCount: "1",
//           ProductCode: "A",
//           ProductType: 2,
//           SubProductCode: "P",
//           itemImg: [],
//           itemdtl: [],
//           noOfDCGiven: 0,
//         },
//         Shipper: {
//           CustomerAddress1: "PUSHPANJALI ECONIRMIT",
//           CustomerAddress2: "12/16, Pragati Nagar, Nanakheda,",
//           CustomerAddress3: "UJJAIN",
//           CustomerCode: "313460",
//           CustomerEmailID: "contact@econirmit.com",
//           CustomerMobile: " 8827373432",
//           CustomerName: "PUSHPANJALI ECONIRMIT",
//           CustomerPincode: "456001",
//           OriginArea: "UJJ",
//         },
//       },
//       Profile: {
//         Api_type: "S",
//         Area: "UJJ",
//         Customercode: "313460",
//         LicenceKey: "hugurthljkfzqmkm3tmjuokqiomjeosk",
//         LoginID: "UJJ23580",
//         Version: "1.8",
//       },
//     };

//     try {
//       setLoading(true);
//       setError(null);

//       const response = await axios.post(
//         "https://apigateway.bluedart.com/in/transportation/waybill/v1/GenerateWayBill",
//         requestData,
//         {
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             JWTToken: token,
//           },
//         }
//       );

//       const awbNo = response.data?.GenerateWayBillResult?.AWBNo;
//       const awbPrint = response.data?.GenerateWayBillResult?.AWBPrintContent;

//       if (awbNo ) {
//         dispatch(updateAwbNumber(orderId, awbNo, awbPrint , jwt));
//         setWaybillData(response.data);
//         localStorage.setItem(`waybill_result_for_${orderId}`, JSON.stringify(response.data));
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Waybill generation failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="px-2 lg:px-36">
//       <div className="flex flex-col justify-center items-center">
//         <Alert variant="filled" severity="success" sx={{ mb: 6, width: "fit-content" }}>
//           <AlertTitle>Payment Success</AlertTitle>
//           Congratulations! Your order has been placed.
//         </Alert>

//         {loading && <p className="text-blue-500 mt-2">Generating Waybill...</p>}
//         {error && <p className="text-red-500 mt-2">{error}</p>}
//       </div>

//       <OrderTraker activeStep={1} />

//       {waybillData?.GenerateWayBillResult?.AWBNo && (
//         <p
//           className="text-black-700 font-semibold text-lg"
//           style={{ textAlign: "center", marginTop: "20px" }}
//         >
//           🧾 AWB Number: {waybillData.GenerateWayBillResult.AWBNo}
//         </p>
//       )}

//       <Grid container className="space-y-5 py-5 pt-20">
//         {order.order?.orderItems?.map((item) => (
//           <Grid
//             key={item._id}
//             container
//             item
//             className="shadow-xl rounded-md p-5 border"
//             sx={{ alignItems: "center", justifyContent: "space-between" }}
//           >
//             <Grid item xs={6}>
//               <div className="flex items-center">
//             <img
//   className="w-[5rem] h-[5rem] object-cover object-top"
//   src={
//     item?.product?.colorVariants?.[0]?.images?.find((img) => img.label === "front")?.url || ""
//   }
//   alt="product"
// />
//                 <div className="ml-5 space-y-2">
//                   <p>{item.product?.title}</p>
//                   <p>Seller: {item?.product?.brand}</p>
//                   <p>₹{item?.price}</p>
//                 </div>
//               </div>
//             </Grid>
//             <Grid item>
//               <AddressCard address={order.order?.shippingAddress} />
//             </Grid>
//           </Grid>
//         ))}
//       </Grid>
//     </div>
//   );
// };

// export default PaymentSuccess;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePayment } from "../../../Redux/Customers/Payment/Action";
import { Alert, AlertTitle, Grid } from "@mui/material";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
import OrderTraker from "../orders/OrderTraker";
import AddressCard from "../adreess/AdreessCard";
import { useParams } from "react-router-dom";
import { getCart } from "../../../Redux/Customers/Cart/Action";

const PaymentSuccess = () => {
  const [paymentId, setPaymentId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const { orderId } = useParams();
  const jwt = localStorage.getItem("jwt");
  const dispatch = useDispatch();
  const cart = useSelector((store) => store.cart);
  const order = useSelector((store) => store.order);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setPaymentId(urlParams.get("razorpay_payment_id"));
    setPaymentStatus(urlParams.get("razorpay_payment_link_status"));
  }, []);

  useEffect(() => {
    dispatch(getCart(jwt));
  }, [jwt, dispatch]);

  useEffect(() => {
    if (orderId) {
      dispatch(getOrderById(orderId));
    }
  }, [orderId, dispatch]);

  useEffect(() => {
    const _order = order?.order;
    if (
      paymentStatus === "paid" &&
      paymentId &&
      _order &&
      _order.shippingAddress
    ) {
      dispatch(updatePayment({ orderId, paymentId, jwt }));
      // ⚠️ AWB generation removed — now handled in backend
    }
  }, [paymentStatus, paymentId, orderId, order.order, dispatch, jwt]);

  return (
    <div className="px-2 lg:px-36">
      <div className="flex flex-col justify-center items-center">
        <Alert variant="filled" severity="success" sx={{ mb: 6, width: "fit-content" }}>
          <AlertTitle>Payment Success</AlertTitle>
          Congratulations! Your order has been placed.
        </Alert>
      </div>

      <OrderTraker activeStep={1} />

      <Grid container className="space-y-5 py-5 pt-20">
        {order.order?.orderItems?.map((item) => (
          <Grid
            key={item._id}
            container
            item
            className="shadow-xl rounded-md p-5 border"
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Grid item xs={6}>
              <div className="flex items-center">
                <img
                  className="w-[5rem] h-[5rem] object-cover object-top"
                  src={
                    item?.product?.colorVariants?.[0]?.images?.find((img) => img.label === "front")?.url || ""
                  }
                  alt="product"
                />
                <div className="ml-5 space-y-2">
                  <p>{item.product?.title}</p>
                  <p>Seller: {item?.product?.brand}</p>
                  <p>₹{item?.price}</p>
                </div>
              </div>
            </Grid>
            <Grid item>
              <AddressCard address={order.order?.shippingAddress} />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PaymentSuccess;
